<template>
  <div
    class="login"
    @keydown.enter="handleSubmit">
    <img
      class="logo"
      src="@/assets/images/logos/formaat-white.svg">
    <div class="login-con">
      <iCard :bordered="false">
        <p slot="title">
          <iIcon type="log-in"/>
          {{ $t('pages.login.welcome_msg') }}
        </p>
        <div class="form-con">
          <iForm
            ref="loginForm"
            :model="form"
            :rules="rules"
            :show-message="false">
            <iFormItem prop="login">
              <iInput
                v-model="form.login"
                :placeholder="$t('pages.login.login_form.login.placeholder')">
                <span slot="prepend">
                  <iIcon
                    :size="16"
                    type="person" />
                </span>
              </iInput>
            </iFormItem>
            <iFormItem prop="password">
              <iInput
                ref="passwordInput"
                v-model="form.password"
                :placeholder="$t('pages.login.login_form.password.placeholder')"
                type="password"
                @focus="form.password = ''"
              >
                <span slot="prepend">
                  <iIcon
                    :size="14"
                    type="locked" />
                </span>
              </iInput>
              <transition name="fade">
                <div
                  v-if="error"
                  class="ivu-form-item-error-tip"
                >
                  {{ $t('pages.login.login_err') }}
                </div>
              </transition>
            </iFormItem>
            <iFormItem>
              <iButton
                :loading="submitting"
                type="primary"
                long
                @click="handleSubmit"
              >
                <template v-if="!submitting">{{ $t('pages.login.login_btn') }}</template>
              </iButton>
            </iFormItem>
          </iForm>
          <p
            class="login-tip"
          >{{ $t('pages.login.login_tip') }}</p>
        </div>
      </iCard>
    </div>
  </div>
</template>

<script>
import pify from 'pify';
import AuthService from '@/services/auth';
import pageComponent from '@/mixins/page-component';

export default {
  mixins: [pageComponent],
  data() {
    return {
      submitting: false,
      error: false,
      form: {
        login: '',
        password: '',
      },
      rules: {
        login: [{ required: true, trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur' }],
      },
    };
  },
  methods: {
    async handleSubmit() {
      if (this.submitting) return;
      this.submitting = true;
      this.error = false;
      try {
        const valid = await this.validate();
        if (!valid) return;
        await AuthService.login(this.form);
        const { redirect } = this.$route.query;
        this.$router.push(redirect || { name: 'home' });
      } catch (error) {
        if (AuthService.isUnauthorized(error)) {
          this.error = true;
          this.$refs.passwordInput.focus();
          return;
        }
        throw error;
      } finally {
        this.submitting = false;
      }
    },
    validate() {
      return pify(this.$refs.loginForm.validate, { errorFirst: false })();
    },
  },
};
</script>

<style lang="less" scoped>
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 44%;
  padding: 40px;
}

.login {
  width: 100%;
  height: 100%;
  // background-image: url('~assets/images/backgrounds/login.jpg');
  background-color: #ff6b45;
  background-size: cover;
  background-position: center;
  position: relative;
  &-con {
    position: absolute;
    right: 160px;
    top: 50%;
    transform: translateY(-60%);
    width: 300px;
    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }
    .form-con {
      padding: 10px 0 0;
    }
    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }
  }
}
</style>
